import React, { Component } from 'react';
import { LinkContainer } from 'react-router-bootstrap';
import { Row, Col, Form, FormGroup, FormControl, ControlLabel, Button } from 'react-bootstrap'
import Api from './../../../Global/Modules/Api'
import { Editor } from '@tinymce/tinymce-react';
const FETCH_URL = "api/pages/admin"

class ContentEdit extends Component {
    constructor(props) {
        super(props)
        this.handleSubmit = this.handleSubmit.bind(this)
        this.handleChange = this.handleChange.bind(this)
        this.handleEditorChange = this.handleEditorChange.bind(this)
        this.state = this.getInitialState()
    }
    getInitialState = () => {
        return {
            data: {
                id: "",
                title: "",
                content: ""
            },
            errors: {}
        }
    }
    handleEditorChange = (e) => {
        this.setState({ data: { ...this.state.data, content: e.target.getContent() } })
    }
    // Function that will be executed when the submit button (Toevoegen) is pressed
    handleSubmit(event) {
        event.preventDefault()

        var formData = new FormData()
        Api.print(this.state.data)
        Object.keys(this.state.data).forEach(e => {
            if (e === "content") formData.append(e, this.state.data.content.toString('html'))
            else formData.append(e, this.state.data[e])
        })

        Api.PostApiWithFile(FETCH_URL, formData, this.props.history)
            .then(response => {
                if (response !== undefined) {
                    Api.print(response)
                    this.setState({ errors: response });
                }
                else {
                    alert("Content updated")
                    // TODO: Show message OK, redirect to the previous page or something like this
                }
            })
    }

    // Function to manage the changes of the text fields and selects
    handleChange(event) {
        const target = event.target
        const name = target.name
        const value = target.type === "checkbox" ? target.checked : target.value
        this.setState({ data: { ...this.state.data, [name]: value } })
    }



    getPageDetail(id) {
        let fetchUrl = `${FETCH_URL}/${id}`
        Api.GetApi(fetchUrl, this.props.history).then(page => {
            Api.print(`Detail of company ${id}`)
            Api.print(page)
            Api.print("----------")


            if (page !== undefined)
                this.setState({
                    data: {
                        ...this.state.data,
                        id: page.id,
                        title: page.title,
                        content: page.description
                    }
                })
        })
    }

    componentWillMount() {
        this.getPageDetail(this.props.id)
    }
    render() {
        let data = this.state.data
        return (
            <div>
                <Row>
                    <Form horizontal onSubmit={this.handleSubmit}>
                        <Col md={12}>
                            {/**<FormGroup controlId="ContentTitel">
                                <Col componentClass={ControlLabel} sm={4}>
                                    Naam *
                                </Col>
                                <Col sm={6}>
                                    <FormControl type="text" placeholder="" defaultValue="reglementen_rcro" />
                                </Col>
                            </FormGroup>**/}

                            <FormGroup controlId="ContentAfbeelding">
                                <Col componentClass={ControlLabel} sm={4}>
                                    Titel *
                                </Col>
                                <Col sm={6}>
                                    <FormControl type="text" name="title" value={data.title} onChange={this.handleChange} required />
                                </Col>
                            </FormGroup>

                            {/**<FormGroup controlId="ContentBericht">
                                <Col componentClass={ControlLabel} sm={4}>
                                    Bericht *
                                </Col>
                                <Col sm={6}>
                                    <FormControl componentClass="textarea" name="description" rows="5" value={data.description} onChange={this.handleChange} />
                                </Col>
                        </FormGroup>**/}

                            <FormGroup controlId="ContentBericht">
                                <Col componentClass={ControlLabel} sm={4}>
                                    Bericht *
                                </Col>
                                <Col sm={12}>
                                    <Editor
                                        apiKey='xf2qbgxw2woyqnls6pdrup90dwguymnu1rzauht57kh622am'
                                        initialValue={data.content}
                                        init={{
                                            height: 2500,
                                            menubar: false,
                                            image_generaltab: false,
                                            images_upload_handler: function (blobInfo, success, failure) {
                                                var formData;
                                                formData = new FormData();
                                                formData.append('file', blobInfo.blob(), blobInfo.filename());

                                                Api.PostApiWithFileCMS('api/pages/file', formData, null)
                                                    .then(response => { success(Api.Url + response.url); })
                                            },
                                            plugins: [
                                                'advlist autolink lists link image charmap print preview anchor',
                                                'searchreplace visualblocks code fullscreen forecolor fontsizeselect',
                                                'insertdatetime media table paste code help wordcount '
                                            ],
                                            toolbar:
                                                'undo redo | formatselect fontsizeselect | bold italic underline |  forecolor backcolor charmap | superscript subscript | \
                                        alignleft aligncenter alignright alignjustify | \
                                        bullist numlist outdent indent | removeformat link | image table code'
                                        }}
                                        onChange={this.handleEditorChange}
                                    />
                                </Col>
                            </FormGroup>
                        </Col>
                        {/**<Col md={4}>
                            Gekozen afbeelding:<br />
                            <Image src={uploadedImage} thumbnail />
                        </Col>**/}
                        <Col md={12}>
                            <FormGroup>
                                <Col sm={12}>
                                    <LinkContainer to="/admin/content"><Button type="button" className="pull-left">Annuleren</Button></LinkContainer>
                                    <Button type="submit" className="pull-right">Wijzigen</Button>
                                </Col>
                            </FormGroup>
                        </Col>
                    </Form>
                </Row>
            </div>
        );
    }
}

export default ContentEdit;


// WEBPACK FOOTER //
// ./src/components/Admin/Modules/Content/Edit.js